/**
 * Shortcut for `HTMLElement.removeAttribute()` method.
 *
 * @param element target element
 * @param att attribute name
 */
const removeAttribute = (element: HTMLElement, att: string): void => element.removeAttribute(att);

export default removeAttribute;
